import "jquery";
import "jquery-deparam";
import "vendor/backbone/stickit";

import "vendor/bootstrap";

import "select2";

import "shared/jquery/clippy";
import "shared/jquery/help_popover";
import "shared/jquery/inline_edit";
import "shared/jquery/multi_select";

import "sparks/invoca_app";
import "sparks/invoca_sync";
